/**
 * WF-Step styles for Shadow DOM
 */

import { css } from 'lit';

import { sharedAnimations } from '../styles/shared.styles.js';

export const wfStepStyles = [
  sharedAnimations,
  css`
  :host {
    display: none;
    width: 100%;
  }

  :host([hidden]) {
    display: none !important;
  }

  :host([active]) {
    display: block;
    animation: wf-stepFadeIn 0.3s ease forwards;
  }

  :host([direction='forward'][active]) {
    animation: wf-stepSlideInRight 0.3s ease forwards;
  }

  :host([direction='backward'][active]) {
    animation: wf-stepSlideInLeft 0.3s ease forwards;
  }

  :host([leaving]) {
    display: block;
    animation: wf-stepFadeOut 0.2s ease forwards;
  }

  .wf-step-content {
    display: flex;
    flex-direction: column;
    gap: var(--wf-spacing-4);
  }

  /* Slotted heading styles */
  ::slotted(h1),
  ::slotted(h2),
  ::slotted(h3) {
    margin: 0;
    font-weight: var(--wf-font-weight-heading);
    color: var(--wf-color-text);
  }

  ::slotted(h2) {
    font-size: var(--wf-font-size-3xl);
  }

  ::slotted(p) {
    margin: 0;
    color: var(--wf-color-text-muted);
    font-size: var(--wf-font-size-xl);
  }
`,
];
